
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkStandardtaskResponsibleUsertypeEnum } from '../models/work-standardtask-responsible-usertype-enum';

export function getCreateStandardtaskDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    containertypeId: new FormControl<number | undefined>(undefined),
    tasktypeId: new FormControl<number | undefined>(undefined),
    taskgroupId: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    userId: new FormControl<number | undefined>(undefined),
    roletypeId: new FormControl<number | undefined>(undefined),
    responsibleUsertype: new FormControl<WorkStandardtaskResponsibleUsertypeEnum | undefined>(undefined),
    duedate: new FormControl<number | undefined>(undefined),
    processingtime: new FormControl<number | undefined>(undefined),
    sortableRank: new FormControl<number | undefined>(undefined),
    visibleForCustomer: new FormControl<boolean | undefined>(false),
    showInMontageplan: new FormControl<boolean | undefined>(false),
    appPhase: new FormControl<number | undefined>(undefined),
    appTaskinfo: new FormControl<string | undefined>(undefined, [Validators.maxLength(1000)]),
    appWaitcreate: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    appCreated: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    appWaitreturn: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    appReturned: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    appTaskTitle: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    syncToInstallationDates: new FormControl<boolean | undefined>(false),
    syncTaskStartToProjectInstallationStartDate: new FormControl<boolean | undefined>(false),
    syncTaskEndToProjectInstallationStartDate: new FormControl<boolean | undefined>(false),
    syncTaskStartToProjectInstallationEndDate: new FormControl<boolean | undefined>(false),
    syncTaskEndToProjectInstallationEndDate: new FormControl<boolean | undefined>(false),
})
;
}
      